<!--
 * @Author: ziqi.tang 3483153081@qq.com
 * @Date: 2026-01-17 12:44:53
 * @LastEditors: ziqi.tang 3483153081@qq.com
 * @LastEditTime: 2026-01-19 09:47:11
 * @FilePath: \xht\git\xht-web-business\src\views\VehicleAdd.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="wrap">
    <div class="nav">
      <span class="back" @click="$router.back()">&#8592;</span>
      <span class="title">添加车牌</span>
    </div>

    <!-- 月卡订单选择 -->
    <div class="card">
      <div class="label">选择月卡订单<span class="req">*</span></div>
      <div class="custom-select-wrapper">
        <div 
          class="custom-select-input input" 
          @click="toggleDropdown"
          :class="{ 'active': dropdownVisible }"
        >
          <span v-if="selectedOrder" class="selected-text">{{ getOrderDisplayName(selectedOrder) }}</span>
          <span v-else class="placeholder-text">请选择月卡订单</span>
          <span class="dropdown-arrow">&#9662;</span>
        </div>
        <div v-if="dropdownVisible" class="custom-select-dropdown">
          <div 
            class="dropdown-item" 
            :class="{ 'selected': !selectedOrderId }"
            @click="selectOrder(null)"
          >
            请选择月卡订单
          </div>
          <div 
            v-for="order in orderList" 
            :key="order.orderId || order.id || order.order_id"
            class="dropdown-item"
            :class="{ 'selected': (order.orderId || order.id || order.order_id) === selectedOrderId }"
            @click="selectOrder(order)"
          >
            {{ getOrderDisplayName(order) }}
          </div>
          <div v-if="orderListLoading" class="dropdown-item loading">加载中...</div>
          <div v-if="hasMoreOrders && !orderListLoading" class="dropdown-footer">
            <button type="button" class="load-more-btn" @click.stop="loadMoreOrders">加载更多订单</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 订单信息显示 -->
    <div class="card" v-if="selectedOrder && productInfo">
      <div class="info-row">
        <span class="info-label">支持泊位数：</span>
        <span class="info-value">{{ productInfo.bindBerthNumbers || '-' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">最大绑定车牌数：</span>
        <span class="info-value">{{ productInfo.maxBindPlateNumbers || '-' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">当前已绑定车牌数：</span>
        <span class="info-value">{{ currentBindPlateCount }}</span>
      </div>
      <div class="info-row" v-if="productInfo.maxBindPlateNumbers && currentBindPlateCount >= productInfo.maxBindPlateNumbers">
        <span class="info-warning">⚠️ 已达到最大绑定数量，无法继续添加</span>
      </div>
    </div>

    <!-- 车牌号输入 -->
    <div class="card" v-if="selectedOrder">
      <div class="label">车牌号<span class="req">*</span></div>
      <div 
        class="input input-plate" 
        @click="openKeyboard"
      >
        <span v-if="form.plateNumber" class="plate-display">{{ form.plateNumber }}</span>
        <span v-else class="plate-placeholder">点击输入车牌号</span>
      </div>
      <div style="height:8px"></div>
      <div class="label">车牌颜色<span class="req">*</span></div>
      <select class="input" v-model="form.plateColor">
        <option 
          v-for="color in availablePlateColors" 
          :key="color.value" 
          :value="color.value"
        >
          {{ color.label }}
        </option>
      </select>
    </div>

    <!-- 邀请他人填写车牌按钮 -->
    <div class="card" v-if="selectedOrder">
      <button 
        class="invite-btn" 
        :class="{ 'disabled': isMaxBindReached }"
        :disabled="isMaxBindReached"
        @click="openQRCode"
      >
        <span class="invite-icon">📱</span>
        <span>邀请他人填写车牌</span>
      </button>
    </div>

    <!-- 二维码弹窗 -->
    <div class="confirm-mask" v-if="qrCodeVisible" @click.self="closeQRCode">
      <div class="qr-dialog">
        <div class="qr-header">
          <span class="qr-title">邀请他人填写车牌</span>
          <span class="qr-close" @click="closeQRCode">×</span>
        </div>
        <div class="qr-content">
          <div class="qr-hint">扫描下方二维码，输入车牌号</div>
          <div class="qr-image-wrapper">
            <img 
              v-if="qrCodeUrl" 
              :src="qrCodeUrl" 
              alt="二维码" 
              class="qr-image"
              @error="handleQRCodeError"
              @load="handleQRCodeLoad"
            />
            <div v-else class="qr-loading">生成中...</div>
            <div v-if="qrCodeError" class="qr-error">
              <div>二维码加载失败</div>
              <div class="qr-error-tip">请检查网络连接或稍后重试</div>
            </div>
          </div>
          <div class="qr-tip">他人扫描后可在手机上输入车牌号</div>
        </div>
      </div>
    </div>

    <!-- 车牌号键盘 -->
    <PlateKeyboard
      :visible="keyboardVisible"
      :value="form.plateNumber"
      :maxLength="8"
      @input="handlePlateInput"
      @close="handleKeyboardClose"
    />

    <div class="actions">
      <button 
        class="btn primary" 
        :disabled="submitting || !canSubmit" 
        @click="submit"
      >
        {{ submitting ? '提交中...' : '提交' }}
      </button>
      <button class="btn" @click="$router.back()">取消</button>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import PlateKeyboard from '@/components/PlateKeyboard.vue'
import { formatUserName } from '@/utils/user'
// eslint-disable-next-line no-unused-vars
import QRCode from 'qrcode' // 保留导入，供后续使用

export default {
  name: 'VehicleAdd',
  components: { PlateKeyboard },
  data () {
    return {
      orderList: [], // 月卡订单列表
      selectedOrderId: '', // 选中的订单ID
      selectedOrder: null, // 选中的订单对象
      productInfo: null, // 产品信息
      form: {
        plateNumber: '',
        plateColor: 'UNKNOWN_COLOR'
      },
      submitting: false,
      keyboardVisible: false,
      qrCodeVisible: false, // 二维码弹窗显示状态
      qrCodeUrl: '', // 二维码图片URL
      qrCodeError: false, // 二维码加载错误状态
      currentBusinessId: null, // 当前商户ID
      orderListPage: 1, // 订单列表当前页码
      orderListPageSize: 10, // 订单列表每页大小
      orderListTotal: 0, // 订单列表总记录数
      orderListLoading: false, // 订单列表是否正在加载
      hasMoreOrders: false, // 是否还有更多订单
      dropdownVisible: false // 下拉菜单是否显示
    }
  },
  computed: {
    // 当前已绑定车牌数（从车牌号数组长度计算，过滤空字符串和null）
    currentBindPlateCount () {
      if (!this.selectedOrder) return 0
      const plates = this.selectedOrder?.plateNumbers || 
                     this.selectedOrder?.plateNumberList || 
                     this.selectedOrder?.plateList || 
                     this.selectedOrder?.plates
      
      // 确保始终从数组长度计算，但需要过滤掉空字符串、null、undefined等无效值
      if (Array.isArray(plates)) {
        // 过滤掉空字符串、null、undefined等无效值，只统计有效的车牌号
        const validPlates = plates.filter(p => {
          if (p == null) return false // 过滤 null 和 undefined
          const str = String(p).trim()
          return str.length > 0 // 过滤空字符串
        })
        return validPlates.length
      }
      // 如果不是数组，返回 0
      return 0
    },
    // 是否可以提交
    canSubmit () {
      if (!this.selectedOrder || !this.form.plateNumber || !this.form.plateNumber.trim()) {
        return false
      }
      // 检查是否已达到最大绑定车牌数（已绑定车牌数大于等于最大绑定车牌数时，无法继续添加）
      if (this.productInfo?.maxBindPlateNumbers != null) {
        if (this.currentBindPlateCount >= this.productInfo.maxBindPlateNumbers) {
          return false
        }
      }
      return true
    },
    // 根据车牌号长度返回可用的车牌颜色选项
    availablePlateColors () {
      const plateLength = this.form.plateNumber ? this.form.plateNumber.trim().length : 0
      
      // 所有颜色选项
      const allColors = [
        { value: 'UNKNOWN_COLOR', label: '未知' },
        { value: 'BLUE_WHITE_COLOR', label: '蓝底白字' },
        { value: 'YELLOW_BLACK_COLOR', label: '黄底黑字' },
        { value: 'WHITE_BLACK_COLOR', label: '白底黑字' },
        { value: 'BLACK_WHITE_COLOR', label: '黑底白字' },
        { value: 'GREEN_WHITE_COLOR', label: '绿底白字' },
        { value: 'GREEN_BLACK_COLOR', label: '绿底黑字' },
        { value: 'GREEN_YELLOW_BLACK_COLOR', label: '绿黄底黑字' }
      ]
      
      // 如果没有输入车牌号，返回所有选项
      if (plateLength === 0) {
        return allColors
      }
      
      // 7位车牌：只能选择"蓝底白字"和"黄底黑字"
      if (plateLength === 7) {
        return [
          { value: 'BLUE_WHITE_COLOR', label: '蓝底白字' },
          { value: 'YELLOW_BLACK_COLOR', label: '黄底黑字' }
        ]
      }
      
      // 8位车牌：只能选择"绿底黑字"和"绿黄底黑字"
      if (plateLength === 8) {
        return [
          { value: 'GREEN_BLACK_COLOR', label: '绿底黑字' },
          { value: 'GREEN_YELLOW_BLACK_COLOR', label: '绿黄底黑字' }
        ]
      }
      
      // 其他长度，返回所有选项
      return allColors
    },
    // 是否已达到最大绑定数量
    isMaxBindReached () {
      if (!this.productInfo || this.productInfo.maxBindPlateNumbers == null) {
        return false
      }
      return this.currentBindPlateCount >= this.productInfo.maxBindPlateNumbers
    }
  },
  async mounted () {
    // 获取商户ID
    await this.fetchBusinessId()
    // 加载第一页订单列表
    if (this.currentBusinessId) {
      await this.fetchOrderList(this.currentBusinessId, 1, false)
    }
    
    // 点击外部区域关闭下拉菜单
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount () {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    // 获取商户ID
    async fetchBusinessId () {
      try {
        // 获取用户ID
        let userId = localStorage.getItem('userId')
        if (!userId) {
          const token = localStorage.getItem('token')
          if (token) {
            try {
              const parts = token.split('.')
              if (parts.length === 3) {
                const payload = JSON.parse(atob(parts[1]))
                userId = payload.userId || payload.uid || payload.sub || null
              }
            } catch (e) { /* ignore */ }
          }
        }
        if (!userId) {
          console.warn('[VehicleAdd] 未能获取用户ID，无法查询商户列表')
          return
        }
        
        // 查询商户列表
        const merchantRes = await request({
          url: '/market/business/list',
          method: 'post',
          data: { administor: userId },
          timeout: 30000
        })
        const merchantList = merchantRes?.data || []
        if (merchantList.length > 0) {
          this.currentBusinessId = merchantList[0].businessId
          console.log('[VehicleAdd] 获取到商户ID:', this.currentBusinessId)
        } else {
          console.warn('[VehicleAdd] 未找到商户信息')
        }
      } catch (e) {
        console.error('[VehicleAdd] 获取商户ID失败:', e)
      }
    },
    // 获取订单列表（分页）
    async fetchOrderList (businessId, page = 1, append = false) {
      if (!businessId) {
        console.warn('[VehicleAdd] 商户ID为空，无法查询订单列表')
        return
      }
      
      // 如果正在加载，不重复请求
      if (this.orderListLoading) {
        return
      }
      
      this.orderListLoading = true
      
      console.log('[VehicleAdd] 开始查询订单列表:', { businessId, page, append })
      
      try {
        const resp = await request({
          url: '/market/business/card/order/search/plate-numbers',
          method: 'get',
          params: {
            businessId: businessId,
            productId: undefined, // 不筛选产品，获取所有订单
            page: page,
            size: this.orderListPageSize
          },
          timeout: 30000
        })
        
        // 解析响应数据
        let responseData = resp?.data || {}
        if (responseData.data) {
          responseData = responseData.data
        }
        
        // 提取订单列表
        const orders = Array.isArray(responseData.orders) ? responseData.orders : []
        const orderTotal = responseData.total || 0 // 订单总数
        
        console.log('[VehicleAdd] 查询到订单列表:', {
          page,
          orderCount: orders.length,
          orderTotal
        })
        
        // 更新订单列表
        if (append) {
          // 追加模式：需要去重，避免重复添加相同的订单
          const existingOrderIds = new Set(this.orderList.map(order => {
            const orderId = order?.orderId || order?.id || order?.order_id
            return String(orderId)
          }))
          const uniqueOrders = orders.filter(order => {
            const orderId = order?.orderId || order?.id || order?.order_id
            return orderId && !existingOrderIds.has(String(orderId))
          })
          this.orderList = [...this.orderList, ...uniqueOrders]
        } else {
          // 重置模式：替换列表
          this.orderList = orders
          this.orderListPage = 1
        }
        
        // 更新分页信息
        this.orderListTotal = orderTotal
        this.orderListPage = page
        
        // 判断是否还有更多数据
        // 如果已加载的订单数量 < 订单总数，说明还有更多订单
        const loadedOrderCount = this.orderList.length
        this.hasMoreOrders = loadedOrderCount < orderTotal
        
        console.log('[VehicleAdd] 订单列表加载完成:', {
          page,
          loadedOrderCount,
          orderTotal,
          hasMore: this.hasMoreOrders
        })
        
        // 如果有更多订单且当前列表不足10条，自动加载下一页（确保下拉列表有足够选项）
        if (this.hasMoreOrders && this.orderList.length < 10) {
          console.log('[VehicleAdd] 订单列表不足10条，自动加载下一页')
          await this.fetchOrderList(businessId, page + 1, true)
        }
      } catch (e) {
        console.error('[VehicleAdd] 查询订单列表失败:', e)
        if (!append) {
          this.orderList = []
        }
      } finally {
        this.orderListLoading = false
      }
    },
    // 获取订单显示名称
    getOrderDisplayName (order) {
      const productName = order?.productName || order?.product_name || '月卡套餐'
      const plates = order?.plateNumbers || order?.plateNumberList || order?.plateList || order?.plates || []
      // 过滤掉空字符串、null、undefined等无效值，只统计有效的车牌号
      let plateCount = 0
      if (Array.isArray(plates)) {
        plateCount = plates.filter(p => {
          if (p == null) return false
          const str = String(p).trim()
          return str.length > 0
        }).length
      } else if (plates) {
        // 如果不是数组，尝试转换为字符串判断
        const str = String(plates).trim()
        plateCount = str.length > 0 ? 1 : 0
      }
      return `${productName} (已绑定${plateCount}个车牌)`
    },
    // 切换下拉菜单显示状态
    toggleDropdown () {
      this.dropdownVisible = !this.dropdownVisible
      
      // 如果下拉菜单打开，且列表不足且还有更多，自动加载
      if (this.dropdownVisible && this.hasMoreOrders && !this.orderListLoading && this.orderList.length < 10) {
        console.log('[VehicleAdd] 下拉菜单打开，自动加载更多订单')
        this.loadMoreOrders()
      }
    },
    // 选择订单
    async selectOrder (order) {
      if (!order) {
        this.selectedOrderId = ''
        this.selectedOrder = null
        this.productInfo = null
        this.dropdownVisible = false
        return
      }
      
      const orderId = order?.orderId || order?.id || order?.order_id
      this.selectedOrderId = orderId ? String(orderId) : ''
      this.selectedOrder = order
      this.dropdownVisible = false
      
      // 获取产品信息
      const productId = order?.productId || order?.product_id
      if (productId) {
        await this.fetchProductInfo(productId)
      } else {
        console.warn('[VehicleAdd] 订单中未找到产品ID')
        this.productInfo = null
      }
    },
    // 加载更多订单
    async loadMoreOrders () {
      if (!this.currentBusinessId || this.orderListLoading || !this.hasMoreOrders) {
        return
      }
      const nextPage = this.orderListPage + 1
      await this.fetchOrderList(this.currentBusinessId, nextPage, true)
    },
    // 处理点击外部区域关闭下拉菜单
    handleClickOutside (event) {
      const wrapper = event.target.closest('.custom-select-wrapper')
      if (!wrapper && this.dropdownVisible) {
        this.dropdownVisible = false
      }
    },
    // 获取产品信息
    async fetchProductInfo (productId) {
      try {
        const resp = await request({
          url: '/market/card/product/search',
          method: 'post',
          data: { productIds: [productId] },
          timeout: 30000
        })
        const products = (resp && (resp.data?.data || resp.data?.records || resp.data?.list || resp.data || [])) || []
        this.productInfo = Array.isArray(products) && products.length > 0 ? products[0] : null
        console.log('[VehicleAdd] 产品信息:', this.productInfo)
      } catch (e) {
        console.error('[VehicleAdd] 获取产品信息失败:', e)
        this.productInfo = null
        alert('获取产品信息失败，请稍后再试')
      }
    },
    // 智能识别车牌颜色（根据位数限制）
    identifyPlateColor (plate) {
      if (!plate || plate.length < 6) {
        return 'UNKNOWN_COLOR'
      }

      const plateUpper = String(plate).trim().toUpperCase()
      const plateLength = plateUpper.length

      // 7位车牌：只能选择"蓝底白字"和"黄底黑字"，默认返回"蓝底白字"
      if (plateLength === 7) {
        const prov = ['京','沪','粤','浙','苏','鲁','川','渝','津','冀','晋','蒙','辽','吉','黑','皖','闽','赣','豫','鄂','湘','桂','琼','贵','云','藏','陕','甘','青','宁','新']
        if (prov.some(p => plateUpper.startsWith(p))) {
          // 可以根据车牌号特征判断是蓝底还是黄底，这里默认返回蓝底白字
          // 如果需要更精确的判断，可以根据车牌号的第二位字符或其他特征
          return 'BLUE_WHITE_COLOR' // 蓝底白字
        }
        // 如果不是标准省份开头，也返回蓝底白字
        return 'BLUE_WHITE_COLOR'
      }

      // 8位车牌：只能选择"绿底黑字"和"绿黄底黑字"，默认返回"绿底黑字"
      if (plateLength === 8) {
        const prov = ['京','沪','粤','浙','苏','鲁','川','渝','津','冀','晋','蒙','辽','吉','黑','皖','闽','赣','豫','鄂','湘','桂','琼','贵','云','藏','陕','甘','青','宁','新']
        if (prov.some(p => plateUpper.startsWith(p))) {
          // 8位车牌通常是新能源车牌，默认返回绿底黑字
          // 如果需要区分绿底黑字和绿黄底黑字，可以根据车牌号特征判断
          return 'GREEN_BLACK_COLOR' // 绿底黑字
        }
        // 如果不是标准省份开头，也返回绿底黑字
        return 'GREEN_BLACK_COLOR'
      }

      // 其他长度，返回未知
      return 'UNKNOWN_COLOR'
    },
    // 打开键盘
    openKeyboard () {
      this.keyboardVisible = true
    },
    // 处理车牌号输入
    handlePlateInput (value) {
      const oldPlateNumber = this.form.plateNumber
      this.form.plateNumber = value
      
      // 自动识别车牌颜色
      if (value && value.trim()) {
        const plateLength = value.trim().length
        const oldPlateLength = oldPlateNumber ? oldPlateNumber.trim().length : 0
        const availableColors = this.availablePlateColors
        // 检查当前颜色是否在可用选项中
        const currentColorValid = availableColors.some(c => c.value === this.form.plateColor)
        
        // 如果车牌号长度变化，或者当前颜色不在可用选项中，或者当前颜色是未知，则自动识别
        if (plateLength !== oldPlateLength || !currentColorValid || this.form.plateColor === 'UNKNOWN_COLOR') {
          // 自动识别并设置
          const identifiedColor = this.identifyPlateColor(value.trim().toUpperCase())
          // 检查识别出的颜色是否在可用选项中
          const isValidColor = availableColors.some(c => c.value === identifiedColor)
          
          if (isValidColor) {
            this.form.plateColor = identifiedColor
          } else {
            // 如果识别出的颜色不在可用选项中，使用第一个可用颜色
            if (availableColors.length > 0) {
              this.form.plateColor = availableColors[0].value
            }
          }
        }
        // 如果车牌号长度没变化且当前颜色在可用选项中，保持不变（不覆盖用户的手动选择）
      } else {
        // 如果清空了车牌号，重置为未知
        this.form.plateColor = 'UNKNOWN_COLOR'
      }
    },
    // 关闭键盘
    handleKeyboardClose () {
      this.keyboardVisible = false
    },
    // 打开二维码弹窗
    async openQRCode () {
      if (!this.selectedOrder) {
        alert('请先选择月卡订单')
        return
      }
      const orderId = this.selectedOrder?.orderId || this.selectedOrder?.id || this.selectedOrder?.order_id
      if (!orderId) {
        alert('订单ID为空，无法生成二维码')
        return
      }
      
      // 参考优惠券页面的二维码生成方式，只包含必要的参数（orderId）
      // 不包含 JWT token，扫码后的页面应该要求用户登录或通过其他方式验证身份
      // 其他信息（productId, productName, remainingPlateCount, maxBindPlateNumbers, bindBerthNumbers等）
      // 都可以通过 orderId 从后端获取，不需要放在二维码中
      
      // 根据环境变量获取业务端URL（与优惠券页面保持一致）
      const env = process.env.VUE_APP_ENV || process.env.NODE_ENV || 'development'
      let businessBaseUrl
      if (env === 'production') {
        businessBaseUrl = 'https://business.xihuiting.com'
      } else if (env === 'staging') {
        businessBaseUrl = 'https://testbusiness.xihuiting.com'
      } else {
        // 开发环境：使用 localhost
        const businessHost = process.env.VUE_APP_BUSINESS_HOST || 'localhost'
        const businessPort = process.env.VUE_APP_BUSINESS_PORT || '8019'
        businessBaseUrl = `http://${businessHost}:${businessPort}`
      }
      
      // 生成二维码链接：只包含 orderId 参数（使用 oid 作为简写，参考优惠券页面的 bid/cid）
      // 注意：使用 hash 路由模式，URL 需要包含 # 符号
      const qrLink = `${businessBaseUrl}/#/vehicle/invite?oid=${encodeURIComponent(orderId)}`
      
      // 使用 qrcode.js 本地生成二维码
      this.qrCodeError = false
      try {
        this.qrCodeUrl = await QRCode.toDataURL(qrLink, {
          width: 300,
          margin: 1,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        })
        console.log('[VehicleAdd] 二维码生成成功:', {
          qrLinkLength: qrLink.length,
          qrLink: qrLink,
          orderId: orderId
        })
      } catch (error) {
        console.error('[VehicleAdd] 生成二维码失败:', error)
        this.qrCodeError = true
        this.qrCodeUrl = ''
      }
      this.qrCodeVisible = true
    },
    // 关闭二维码弹窗
    closeQRCode () {
      this.qrCodeVisible = false
      this.qrCodeUrl = ''
      this.qrCodeError = false
    },
    // 处理二维码加载错误
    handleQRCodeError () {
      console.error('[VehicleAdd] 二维码加载失败')
      this.qrCodeError = true
      // 如果 URL 太长，尝试使用更小的尺寸和更低的错误纠正级别
      if (this.qrCodeUrl && this.qrCodeUrl.length > 2000) {
        console.warn('[VehicleAdd] 二维码 URL 过长，尝试使用更小的尺寸')
        const originalUrl = this.qrCodeUrl
        // 尝试使用更小的尺寸和更低的错误纠正级别
        this.qrCodeUrl = originalUrl.replace('size=400x400&ecc=H', 'size=300x300&ecc=M')
      }
    },
    // 处理二维码加载成功
    handleQRCodeLoad () {
      console.log('[VehicleAdd] 二维码加载成功')
      this.qrCodeError = false
    },
    // 获取商户ID（从订单中获取，或从 businessContext 中获取）
    getBusinessIdFromOrder (order) {
      if (!order) return null
      // 尝试多种可能的字段名
      let businessId = order.businessId || order.business_id || null
      
      // 如果订单中没有 businessId，尝试从 businessContext 中获取
      if (!businessId) {
        try {
          const raw = sessionStorage.getItem('in_park_plates_payload')
          if (raw) {
            const payload = JSON.parse(raw)
            const businessContext = payload?.businessContext
            if (businessContext) {
              businessId = businessContext.businessId || businessContext.business_id || null
            }
          }
        } catch (e) {
          console.warn('[VehicleAdd] 从 businessContext 获取 businessId 失败:', e)
        }
      }
      
      return businessId
    },
    // 获取操作人ID（参考 Profile.vue 的实现）
    getOperatorId () {
      // 优先从 store 的 userInfo 获取（与 Profile.vue 保持一致）
      if (this.$store && this.$store.getters) {
        const userInfo = this.$store.getters.userInfo
        if (userInfo) {
          const uid = userInfo.userId || userInfo.id
          if (uid) return uid
        }
        // 如果 userInfo 中没有，尝试从 getters 直接获取
        const userId = this.$store.getters.userId || this.$store.getters.user_id
        if (userId) return userId
      }
      
      // 其次从 localStorage 获取（与 Profile.vue 保持一致）
      const localStorageUserId = localStorage.getItem('userId')
      if (localStorageUserId) return localStorageUserId
      
      // 最后从 token 解析（与 Profile.vue 保持一致）
      try {
        const token = localStorage.getItem('token') || ''
        const parts = (token || '').split('.')
        if (parts.length === 3) {
          const payload = JSON.parse(atob(parts[1]))
          // 尝试多种可能的字段名（与 Profile.vue 保持一致）
          return payload.userId || payload.uid || payload.sub || payload.user_id || payload.id || null
        }
      } catch (e) {
        console.warn('[VehicleAdd] 从 token 解析 operatorId 失败:', e)
      }
      
      return null
    },
    // 获取操作人名称（用于生成月卡操作记录）
    // 注意：应该上传账号的名称，与个人中心页面"您好，xxxx"中的xxxx保持一致
    getOperatorName () {
      // 使用与 Profile.vue 中 displayName 相同的逻辑
      // 优先从 store 的 getters 获取 realName 或 nickname
      if (this.$store && this.$store.getters) {
        const realName = this.$store.getters.realName
        const nickname = this.$store.getters.nickname
        if (realName && realName.trim()) {
          return realName.trim()
        }
        if (nickname && nickname.trim()) {
          return nickname.trim()
        }
        // 如果 getters 中没有，使用 formatUserName 从 userInfo 中获取
        const userInfo = this.$store.getters.userInfo
        if (userInfo) {
          const formattedName = formatUserName(userInfo)
          if (formattedName && formattedName !== '用户' && formattedName.trim()) {
            return formattedName.trim()
          }
        }
      }
      // 如果 store 中获取不到，尝试从 token 解析
      try {
        const token = localStorage.getItem('token') || ''
        const parts = (token || '').split('.')
        if (parts.length === 3) {
          const payload = JSON.parse(atob(parts[1]))
          // 优先使用名称字段，不使用账号字段（username）
          return payload.realName || payload.name || payload.nickname || ''
        }
      } catch (e) {
        // ignore
      }
      // 默认返回空字符串，后端会使用 "system" 作为默认值
      return ''
    },
    // 验证车牌号格式
    validatePlateNumber (plateNumber) {
      if (!plateNumber || !plateNumber.trim()) {
        return false
      }
      const trimmed = plateNumber.trim().toUpperCase()
      // 检查长度：应该是7位或8位
      if (trimmed.length !== 7 && trimmed.length !== 8) {
        return false
      }
      // 使用平台端的车牌号验证规则
      // 支持：省份简称 + A-Z + 6个A-Z0-9字符（共8个字符，新能源车牌）
      //      省份简称 + A-Z + 4个A-Z0-9字符 + 挂学警港澳（共7个字符）
      //      省份简称 + A-Z + 5个A-Z0-9字符（共7个字符，普通车牌）
      const plateRegex = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z]([A-Z0-9]{6}|[A-Z0-9]{4}[挂学警港澳]|[A-Z0-9]{5})$/
      return plateRegex.test(trimmed)
    },
    // 提交
    async submit () {
      if (!this.selectedOrder) {
        alert('请选择月卡订单')
        return
      }
      if (!this.form.plateNumber || !this.form.plateNumber.trim()) {
        alert('请输入车牌号')
        return
      }
      
      // 验证车牌号格式
      const plateNumber = this.form.plateNumber.trim().toUpperCase()
      if (!this.validatePlateNumber(plateNumber)) {
        alert('车牌号无效，无法添加车牌号。请输入正确的车牌号格式（7位或8位）')
        return
      }
      
      // 检查是否已达到最大绑定车牌数（已绑定车牌数大于等于最大绑定车牌数时，无法继续添加）
      if (this.productInfo?.maxBindPlateNumbers != null) {
        if (this.currentBindPlateCount >= this.productInfo.maxBindPlateNumbers) {
          alert(`已达到最大绑定数量（最大绑定车牌数：${this.productInfo.maxBindPlateNumbers}），无法继续添加`)
          return
        }
      }
      
      // 检查车牌号是否已存在
      const plates = this.selectedOrder?.plateNumbers || 
                     this.selectedOrder?.plateNumberList || 
                     this.selectedOrder?.plateList || 
                     this.selectedOrder?.plates || []
      const plateArray = Array.isArray(plates) ? [...plates] : [plates]
      const normalizedNewPlate = plateNumber // 使用已验证并规范化的车牌号
      const exists = plateArray.some(p => String(p).trim().toUpperCase() === normalizedNewPlate)
      if (exists) {
        alert('该车牌号已绑定到该订单，无需重复添加')
        return
      }
      
      this.submitting = true
      try {
        const orderId = this.selectedOrder?.orderId || this.selectedOrder?.id || this.selectedOrder?.order_id
        if (!orderId) {
          alert('订单ID为空，无法提交')
          return
        }
        
        // 构建新的车牌号列表
        const newPlateArray = [...plateArray, normalizedNewPlate]
        
        // 构建新的车牌颜色列表
        const currentColors = this.selectedOrder?.plateColors || this.selectedOrder?.plate_colors || []
        const colorArray = Array.isArray(currentColors) ? [...currentColors] : []
        const newColorArray = [...colorArray, this.form.plateColor]
        
        // 构建更新请求
        const updatePayload = {
          orderId: orderId,
          plateNumbers: newPlateArray,
          plateColors: newColorArray.length > 0 ? newColorArray : undefined,
          productId: this.selectedOrder?.productId || this.selectedOrder?.product_id,
          status: this.selectedOrder?.status,
          cardValidStartTime: this.selectedOrder?.cardValidStartTime || this.selectedOrder?.card_valid_start_time,
          cardValidEndTime: this.selectedOrder?.cardValidEndTime || this.selectedOrder?.card_valid_end_time,
          totalAmount: this.selectedOrder?.totalAmount || this.selectedOrder?.total_amount || 0,
          paidAmount: this.selectedOrder?.paidAmount || this.selectedOrder?.paid_amount || 0,
          actualAmount: this.selectedOrder?.actualAmount || this.selectedOrder?.actual_amount || 0,
          // 添加操作人名称和操作描述，用于生成月卡操作记录
          operatorName: this.getOperatorName(),
          operationDesc: `添加车牌号：${normalizedNewPlate}`
        }
        
        if (!updatePayload.totalAmount && updatePayload.totalAmount !== 0) {
          alert('订单缺少必填字段 totalAmount，无法提交')
          return
        }
        
        console.log('[VehicleAdd] 提交更新请求:', updatePayload)
        await request({ 
          url: '/market/card/order/update', 
          method: 'post', 
          data: updatePayload 
        })
        
        // 注意：操作记录由后端自动生成，无需前端手动添加
        // 后端会根据车牌号变化自动生成"人工录入：新增车辆：xxx"的操作记录
        
        // 更新本地订单数据，刷新显示
        if (this.selectedOrder) {
          // 更新当前选中的订单
          this.selectedOrder.plateNumbers = newPlateArray
          this.selectedOrder.plateNumberList = newPlateArray
          this.selectedOrder.plateList = newPlateArray
          this.selectedOrder.plates = newPlateArray
          this.selectedOrder.plateColors = newColorArray
          this.selectedOrder.plate_colors = newColorArray
          
          // 更新订单列表中的对应订单
          const currentOrderId = this.selectedOrderId
          const orderIndex = this.orderList.findIndex(order => {
            const orderId = order?.orderId || order?.id || order?.order_id
            return orderId === currentOrderId
          })
          if (orderIndex >= 0) {
            this.orderList[orderIndex] = { ...this.selectedOrder }
          }
        }
        
        // 清空车牌号输入框
        this.form.plateNumber = ''
        this.form.plateColor = 'UNKNOWN_COLOR'
        
        alert('添加车牌成功')
        // 不跳转，保持在当前页面，数据已自动刷新
      } catch (e) {
        console.error('[VehicleAdd] 提交失败:', e)
        alert(e?.response?.data?.message || '提交失败，请稍后再试')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.wrap { 
  max-width: 430px; 
  margin: 0 auto; 
  background: #f7f8fa; 
  min-height: 100vh; 
  padding-bottom: 80px; 
}

.nav { 
  height: 50px; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
  background: #fff; 
  box-shadow: 0 1px 0 #f0f0f0; 
  position: relative; 
}

.back { 
  position: absolute; 
  left: 0; 
  padding-left: 14px; 
  font-size: 22px; 
  cursor: pointer; 
}

.title { 
  font-size: 18px; 
  font-weight: bold; 
}

.card { 
  background: #fff; 
  border-radius: 12px; 
  margin: 14px 14px 0; 
  padding: 14px 14px; 
  box-shadow: 0 2px 8px #f0f0f0; 
}

.label { 
  font-size: 14px; 
  color: #888; 
  margin-bottom: 4px; 
}

.req { 
  color: #ff4444; 
  margin-left: 4px; 
}

.input { 
  width: 100%; 
  background: #f7f8fa; 
  border: none; 
  border-radius: 10px; 
  padding: 10px 12px; 
  font-size: 14px; 
  color: #222; 
  outline: none; 
  box-sizing: border-box;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
  position: relative;
}

.input:focus {
  background: #fff;
  box-shadow: 0 0 0 2px rgba(35, 138, 255, 0.2);
}

/* 下拉箭头样式 */
select.input {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px;
  padding-right: 36px;
  background-color: #f7f8fa;
}

select.input:focus {
  background-color: #fff;
}

select.input option {
  padding: 10px 12px;
  background: #fff;
  color: #222;
}

.input-plate {
  cursor: pointer;
  display: flex;
  align-items: center;
  min-height: 40px;
}

.plate-display {
  color: #222;
  font-weight: 500;
}

.plate-placeholder {
  color: #999;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  font-size: 14px;
}

.info-label {
  color: #888;
}

.info-value {
  color: #222;
  font-weight: 500;
}

.info-warning {
  color: #ff4444;
  font-size: 13px;
  width: 100%;
  text-align: center;
  padding: 8px 0;
}

.actions { 
  display: flex; 
  gap: 12px; 
  margin: 18px 14px 0; 
}

.btn { 
  flex: 1; 
  background: #fff; 
  color: #888; 
  font-size: 16px; 
  font-weight: 600; 
  border: none; 
  border-radius: 12px; 
  padding: 10px 0; 
  box-shadow: 0 2px 8px #eee; 
  cursor: pointer;
}

.btn.primary { 
  background: #238aff; 
  color: #fff; 
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.invite-btn {
  width: 100%;
  background: linear-gradient(90deg, #4ca1ff, #70e1f5);
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  border: none;
  border-radius: 12px;
  padding: 12px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.invite-btn:active:not(:disabled) {
  opacity: 0.8;
}

.invite-btn:disabled,
.invite-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #ccc;
}

.invite-icon {
  font-size: 20px;
}

/* 二维码弹窗样式 */
.confirm-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.qr-dialog {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 320px;
  padding: 0;
  overflow: hidden;
}

.qr-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.qr-title {
  font-size: 18px;
  font-weight: bold;
  color: #222;
}

.qr-close {
  font-size: 28px;
  color: #999;
  cursor: pointer;
  line-height: 1;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s;
}

.qr-close:hover {
  background: #f7f8fa;
}

.qr-content {
  padding: 24px 20px;
  text-align: center;
}

.qr-hint {
  font-size: 15px;
  color: #666;
  margin-bottom: 20px;
}

.qr-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  min-height: 300px;
}

.qr-image {
  width: 300px;
  height: 300px;
  border: 1px solid #eee;
  border-radius: 8px;
}

.qr-loading {
  color: #999;
  font-size: 14px;
}

.qr-error {
  text-align: center;
  padding: 20px;
  color: #ff4444;
}

.qr-error-tip {
  font-size: 12px;
  color: #888;
  margin-top: 8px;
}

.qr-tip {
  font-size: 13px;
  color: #999;
  margin-top: 16px;
}

.qr-error-tip {
  font-size: 12px;
  color: #888;
  margin-top: 8px;
}

.qr-tip {
  font-size: 13px;
  color: #999;
  margin-top: 16px;
}

.custom-select-wrapper {
  position: relative;
  width: 100%;
}

.custom-select-input {
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.custom-select-input.active {
  background: #fff;
  box-shadow: 0 0 0 2px rgba(35, 138, 255, 0.2);
}

.selected-text {
  color: #222;
  flex: 1;
}

.placeholder-text {
  color: #999;
  flex: 1;
}

.dropdown-arrow {
  color: #666;
  font-size: 12px;
  transition: transform 0.2s;
  margin-left: 8px;
}

.custom-select-input.active .dropdown-arrow {
  transform: rotate(180deg);
}

.custom-select-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
}

.dropdown-item {
  padding: 12px;
  cursor: pointer;
  font-size: 14px;
  color: #222;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.2s;
}

.dropdown-item:last-child {
  border-bottom: none;
}

.dropdown-item:hover {
  background: #f7f8fa;
}

.dropdown-item.selected {
  background: #e8f4ff;
  color: #238aff;
}

.dropdown-item.loading {
  text-align: center;
  color: #999;
  cursor: default;
}

.dropdown-item.loading:hover {
  background: transparent;
}

.dropdown-footer {
  padding: 8px;
  border-top: 1px solid #f0f0f0;
  text-align: center;
}

.load-more-btn {
  background: transparent;
  border: none;
  color: #3572e6;
  font-size: 13px;
  cursor: pointer;
  padding: 4px 8px;
  text-decoration: underline;
  width: 100%;
}

.load-more-btn:hover {
  color: #238aff;
}
</style>

